// material-ui
import { CardActions } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { Button, Divider, Grid, Typography } from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickAlert from 'components/RedQuickAlert'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import CuratedSeriesListForm from 'components/CuratedSeriesListForm'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_curatedSeriesList,
  get_selected_curatedSeriesList,
  is_curatedSeriesList_busy,
  setSelectedcuratedSeriesList,
} from 'features/curatedSeriesList/curatedSeriesList-slice'
import { get_all_releaseScheduleAction } from 'features/releaseScheduleAction/releaseScheduleAction-slice'
import { get_all_series } from 'features/series/series-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let curatedSeriesList_list = useSelector(get_all_curatedSeriesList)
  let curatedSeriesList_busy = useSelector(is_curatedSeriesList_busy)
  let curatedSeriesList = useSelector(get_selected_curatedSeriesList)
  let series_list = useSelector(get_all_series)
  let releaseScheduleAction_list = useSelector(get_all_releaseScheduleAction)
  const [modelChanges, setModelChanges] = React.useState(null)
  const [modelValid, setModelValid] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [modelDirty, setModelDirty] = React.useState(null)
  const [releaseActionArgs, setReleaseActionArgs] = React.useState(null)
  const [tags, setTags] = React.useState(null)
  const [tagsDirty, setTagsDirty] = React.useState(null)
  const [genre, setGenre] = React.useState(null)
  const [genreDirty, setGenreDirty] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_curated_series_list({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.load_series({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_curated_lists({
          ok: false,
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && curatedSeriesList?.id) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_curated_list({
          curatedListId: (() => {
            function getModelId(): any {
              return curatedSeriesList?.id
            }
            return getModelId()
          })(),
        }),
      )
    }
  }, [claims?.player, curatedSeriesList?.id])
  useEffect(() => {
    if (claims?.player && curatedSeriesList?.id && releaseActionArgs) {
      dispatch(
        autoThunks.update_release_schedule_actions_for_curated_list({
          args: (() => {
            function getReleaseScheduleActionArgs(): any {
              return releaseActionArgs
            }
            return getReleaseScheduleActionArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, curatedSeriesList?.id, releaseActionArgs])
  useEffect(() => {
    function on_set_selected_series() {
      let item = get_current_model()
      if (item) {
        setTags((item.tags || []).map((v) => v.name).filter((x) => x))
        setGenre((item.genre || []).map((v) => v.name).filter((x) => x))
        setGenreDirty(null)
        setTagsDirty(null)
      } else {
        setTags([])
        setGenre([])
        setGenreDirty(null)
        setTagsDirty(null)
      }
    }
    on_set_selected_series()
  }, [get_current_model()?.id])

  function get_current_model() {
    return {
      ...(curatedSeriesList || {}),
      ...(modelChanges || {}),
    }
  }

  function modelComponent(): any {
    return (
      <>
        {SC.sharedList(
          (curatedSeriesList_list || []).filter((x) => !x.deleted),
          SC.sharedListItemBuilder,
          (item) => {
            return {
              name: item?.name || TitleService('Unknown'),
              date: item?.created || item.updated,
              statusColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.dark.main
                  : theme.palette.primary.light,
              getIcon: () => {
                return (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-list-details"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#597e8d"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M13 5h8" />
                    <path d="M13 9h5" />
                    <path d="M13 15h8" />
                    <path d="M13 19h5" />
                    <rect x="3" y="4" width="6" height="6" rx="1" />
                    <rect x="3" y="14" width="6" height="6" rx="1" />
                  </svg>
                )
              },
            }
          },
          (item) => {
            dispatch(setSelectedcuratedSeriesList(item?.id))
            setModelChanges({})
            setModelValid(null)
            setModelDirty(null)
            setContextId(uuid())
          },
        )}
      </>
    )
  }

  let output_modelComponent = modelComponent()

  function modelItemForm(storeModelAsync: any, deleteModelAsync: any): any {
    return (
      <>
        <Grid item xs={12} sm={12} md={12}>
          <CuratedSeriesListForm
            page={undefined}
            form={get_current_model()}
            onUpdate={(update, valid, dirty) => {
              setModelChanges({
                ...modelChanges,
                ...update,
              })
              setModelValid(valid)
              setModelDirty(dirty)
            }}
            context={{
              id: contextId,
            }}
          />
          <SC.CuratadSeriesListMediaReleaseAction
            curatedSeriesList={curatedSeriesList}
            actions={releaseScheduleAction_list}
            onChange={(args) => {
              setReleaseActionArgs(args)
            }}
          />
          <Grid container spacing={gridSpacing}>
            <Grid item xs={6} sm={6} md={6}>
              {SC.sharedList(
                (series_list || [])
                  .filter((x) => !x.deleted)
                  .filter((x) => {
                    let temp = get_current_model()
                    if (temp?.series?.find((v) => v.id === x)) {
                      return false
                    }
                    return true
                  }),
                SC.sharedListItemBuilder,
                (item) => {
                  return {
                    name: item?.name || TitleService('Unknown'),
                    date: item?.created || item.updated,
                    statusColor:
                      theme.palette.mode === 'dark'
                        ? theme.palette.dark.main
                        : theme.palette.primary.light,
                    getIcon: () => {
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-list-details"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#597e8d"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 5h8" />
                          <path d="M13 9h5" />
                          <path d="M13 15h8" />
                          <path d="M13 19h5" />
                          <rect x="3" y="4" width="6" height="6" rx="1" />
                          <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                      )
                    },
                  }
                },
                (item) => {
                  let temp = { ...(modelChanges || {}) }
                  temp.series = temp.series || []
                  if (!temp.series.some((v) => v.id === item.id)) {
                    temp.series.push(item)
                    setModelChanges(temp)
                    setModelDirty(true)
                  }
                },
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <Typography variant="h5" sx={{ m: 0 }}>
                {TitleService('Series Playlist Order')}
              </Typography>
              <rq.RedQuickOrderedList
                value={get_current_model().series || []}
                rowHeight={60}
                createElement={(item) => {
                  let series_item = series_list.find((v) => v.id === item.i)
                  return SC.renderSeriesItem(series_item, theme, () => {
                    let temp = get_current_model()
                    temp.series = temp.series || []
                    temp.series = temp.series.filter(
                      (x) => series_item.id !== x.id,
                    )
                    setModelChanges(temp)
                    setModelValid(
                      modelValid !== null ? modelValid && true : true,
                    )
                    setModelDirty(true)
                  })
                }}
                onChange={(items) => {
                  console.log(items)
                  let temp = get_current_model()
                  temp.series = temp.series || []
                  if (
                    JSON.stringify(temp.series) !==
                    JSON.stringify(items.map((v) => v.id))
                  ) {
                    temp.series = items.map((v) => {
                      return series_list.find((y) => y.id === v.i)
                    })
                    setModelChanges(temp)
                    setModelValid(
                      modelValid !== null ? modelValid && true : true,
                    )
                    setModelDirty(true)
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
          <Grid container spacing={2}>
            <Grid item>
              <AnimateButton>
                <Button
                  variant="contained"
                  onClick={async () => {
                    dispatch(setSelectedcuratedSeriesList(null))
                    setModelChanges({})
                    setModelValid(null)
                    setModelDirty(null)
                  }}
                >
                  {TitleService('New')}
                </Button>
              </AnimateButton>
            </Grid>
            {modelDirty && modelValid && (
              <Grid item>
                <AnimateButton>
                  <Button
                    variant="contained"
                    onClick={async () => {
                      await dispatch(storeModelAsync)
                      dispatch(setSelectedcuratedSeriesList(null))
                      setModelChanges({})
                      setModelValid(null)
                      setModelDirty(null)
                      setContextId(uuid())
                    }}
                  >
                    {TitleService('Save')}
                  </Button>
                </AnimateButton>
              </Grid>
            )}
            {curatedSeriesList?.id && (
              <Grid item>
                <RedQuickAlert
                  button={
                    <Button
                      variant="contained"
                      sx={{
                        background: theme.palette.error.main,
                        '&:hover': { background: theme.palette.error.dark },
                      }}
                      disabled={curatedSeriesList_busy}
                      onClick={async () => {}}
                    >
                      {TitleService('Delete')}
                    </Button>
                  }
                  cancelText={TitleService('No')}
                  affirmativeText={TitleService('Yes')}
                  onOk={async () => {
                    await dispatch(deleteModelAsync)
                    dispatch(setSelectedcuratedSeriesList(null))
                    setModelChanges({})
                    setModelValid(null)
                    setModelDirty(null)
                    setContextId(uuid())
                  }}
                  title={TitleService('Are you sure?')}
                  description={TitleService('This is a system wide change.')}
                />
              </Grid>
            )}
          </Grid>
        </CardActions>
      </>
    )
  }

  let output_modelItemForm = modelItemForm(
    autoThunks.storeCuratedSeriesListAsync({
      model: (() => {
        function getCuratedSeriesList(): any {
          return {
            ...(curatedSeriesList || {}),
            ...(modelChanges || {}),
          }
        }
        return getCuratedSeriesList()
      })(),
    }),
    autoThunks.deleteCuratedSeriesListAsync({
      id: (() => {
        function getModelId(): any {
          return curatedSeriesList?.id
        }
        return getModelId()
      })(),
    }),
  )

  function main_card(modelList: any, modelForm: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12} xl={3} md={3}>
          <MainCard title={TitleService('Curated Series Lists(Not used)')}>
            {modelList}
          </MainCard>
        </Grid>
        <Grid item xs={12} xl={9} md={9}>
          <MainCard
            title={
              curatedSeriesList?.name ||
              TitleService('Curated Series List(Not used)')
            }
          >
            {modelForm}
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(output_modelComponent, output_modelItemForm)

  return output_main_card
}
